import { styled } from '@mui/system';
import { Box, Pagination, Button } from '@mui/material';

export const Root = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column'
}));

export const ContentContainer = styled(Box)(({ theme }) => ({
  padding: theme.spacing(1),
  margin: theme.spacing(3, 3, 2, 3),
  [theme.breakpoints.down('md')]: {
    margin: theme.spacing(2, 0, 0, 0)
  },
  [theme.breakpoints.down('sm')]: {
    margin: 0
  }
}));

export const FilterButtonContainer = styled(Box)(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: 'auto 170px 210px',
  gridTemplateAreas: '"filter createContactBtn createAddressbookBtn"',
  gridGap: theme.spacing(1),
  padding: theme.spacing(2, 4, 2, 4),
  width: '100%',
  backgroundColor: '#EEE',
  zIndex: 1100,
  [theme.breakpoints.down('md')]: {
    display: 'flex'
  },
  '@media (max-width: 420px)': {
    gridTemplateColumns: 'auto auto auto'
  },
  [theme.breakpoints.down('sm')]: {
    padding: '32px 8px 16px 8px'
  }
}));

export const CreateAddressbookBtn = styled(Button)(() => ({
  gridArea: 'createAddressbookBtn'
}));

export const CreateContactBtn = styled(Button)(() => ({
  gridArea: 'createContactBtn'
}));

export const AddButtonLabel = styled('span')(({ theme }) => ({
  color: 'rgba(0, 0, 0, 0.87)',
  marginLeft: theme.spacing(0.5)
}));

export const StyledPagination = styled(Pagination)(({ theme }) => ({
  paddingBottom: theme.spacing(3),
  '& > ul': {
    justifyContent: 'center'
  }
}));

export const PaginationPlaceholder = styled(Box)(() => ({
  height: 1
}));

export const AddressBookContainer = styled(Box)(() => ({
  position: 'relative'
}));

export const EmptyDiv = styled(Box)(() => ({
  height: '49px'
}));

export const PaginationWrapper = styled(Box, {
  shouldForwardProp: prop => prop !== 'isMobile'
})(({ isMobile }) => ({
  ...(isMobile && {
    marginBottom: '70px',
    marginTop: '-50px'
  })
}));
